import styled from 'styled-components';
import Button from '../../../../components/button/Button';
import { LinkIcon } from '../../../../assets/icons/LinkIcon';
import { TabProps } from '../../../../blocks/tabs-vertical/TabsVertical';
import ExpandCollapseTaskChecklistHeaders from '../checklist-step/ExpandCollapseTaskChecklistHeaders';
import { openFieldMaps } from '../../../../utils/fieldMaps';

interface Props extends TabProps {
  projectNumber?: string;
}

const VoltageSetStep = (props: Props) => {
  const { projectNumber } = props;

  return (
    <ExpandCollapseTaskChecklistHeaders isCollapsable={false} header={'Spændingssat'} readOnly>
      <FieldMapsText>
        Åben Field Maps og udfyld den relevante data. Vær opmærksom på, at linket åbner i din browser og du skal tilbage i
        Work, når du har udfyldt den relevante data
      </FieldMapsText>
      <Button onClick={() => openFieldMaps(projectNumber)}>
        <LinkIcon />
        Vis i Field Maps
      </Button>
    </ExpandCollapseTaskChecklistHeaders>
  );
};

const FieldMapsText = styled.p`
  margin: 15px 0px;
`;

export default VoltageSetStep;
